/**
 * Foco automático só com mouse ou trackpad. Em telas de toque, focar um campo ao abrir a página
 * sobe o teclado e cobre a tela antes de a pessoa decidir.
 */
export function canAutoFocus(): boolean {
  return typeof window.matchMedia !== 'function' || window.matchMedia('(pointer: fine)').matches
}
